import { ErrorLogComponent } from '@cian/error-log-component';
import { UiKitContextProvider } from '@cian/ui-kit/context';
import { FC } from 'react';
import { Provider } from 'react-redux';
import { IApplicationContext } from 'shared/common/types/applicationContext';
import { TReduxStore } from 'shared/common/types/redux';
import { ApplicationContext } from 'shared/common/utils/applicationContext';
import { PageContainer } from '../../Page';

export interface IApplicationProps {
  context: IApplicationContext;
  reduxStore: TReduxStore;
}

export const LandingSellerApp: FC<IApplicationProps> = ({ reduxStore, context }) => {
  const {
    logger,
    custom: { initialDeviceType },
  } = context;

  return (
    <ErrorLogComponent logger={logger}>
      <ApplicationContext.Provider value={context}>
        <UiKitContextProvider deviceType={initialDeviceType}>
          <Provider store={reduxStore}>
            <PageContainer />
          </Provider>
        </UiKitContextProvider>
      </ApplicationContext.Provider>
    </ErrorLogComponent>
  );
};
